import { useEffect, useMemo, useState } from 'react';
import { FieldType, } from '../types';
export var useRegisterField = function (fieldArrayState, formState, providedName, fieldType, isArray, defaultValue) {
    var fieldName = useMemo(function () {
        return (fieldArrayState === null || fieldArrayState === void 0 ? void 0 : fieldArrayState.name) &&
            !providedName.match(new RegExp('^' + String(fieldArrayState.name)))
            ? fieldArrayState.name + "." + providedName
            : providedName;
    }, [fieldArrayState === null || fieldArrayState === void 0 ? void 0 : fieldArrayState.name, providedName]);
    var registerField = useMemo(function () { return formState === null || formState === void 0 ? void 0 : formState.registerField; }, [formState === null || formState === void 0 ? void 0 : formState.registerField]);
    var isInsideForm = useMemo(function () { return Boolean(registerField); }, [registerField]);
    var _a = useState(false), isRegistered = _a[0], setIsRegistered = _a[1];
    useEffect(function () {
        if (isInsideForm) {
            var unmountFunc = registerField(fieldName, fieldType !== null && fieldType !== void 0 ? fieldType : (isArray ? FieldType.ARRAY : undefined), defaultValue);
            setIsRegistered(true);
            return unmountFunc;
        }
        else {
            if (fieldType) {
                console.warn('Указанный fieldType будет проигнорирован вне контекста формы. Разместите' +
                    ' ваш инпут внутри компонента формы, чтоб это заработало');
            }
            else {
                setIsRegistered(true);
            }
        }
    }, [
        defaultValue,
        fieldName,
        fieldType,
        isArray,
        isInsideForm,
        registerField,
        setIsRegistered,
    ]);
    var fields = useMemo(function () { return formState === null || formState === void 0 ? void 0 : formState.fields; }, [formState === null || formState === void 0 ? void 0 : formState.fields]);
    var field = useMemo(function () { return fields === null || fields === void 0 ? void 0 : fields[fieldName]; }, [fields, fieldName]);
    return { field: field, isInsideForm: isInsideForm, isRegistered: isRegistered, name: fieldName };
};
